import { serialize } from '@/utils/index';
import errorCode from '@/const/errorCode';
import router from '@/router/index';
import axios from 'axios';
import store from '@/store';
import { showToast } from 'vant';

const service = axios.create({
  // axios中请求配置有baseURL选项，表示请求URL公共部分
  baseURL: process.env.VUE_APP_BASE_API,
  // 超时
  timeout: '请求超时,刷新重试',
});
axios.defaults.timeout = 30000;
// 返回其他状态吗
service.defaults.validateStatus = function (status) {
  return status >= 200 && status <= 500; // 默认的
};
// 跨域请求，允许保存cookie
service.defaults.withCredentials = true;

// HTTPrequest拦截
service.interceptors.request.use(
  (config) => {
    if (config.data && config.data.queryParams) {
      Object.keys(config.data.queryParams).forEach((key) => {
        const val = config.data.queryParams[key];
        if (val === null || val === '') {
          delete config.data.queryParams[key];
        }
      });
    }
    const TENANT_ID = store.state.userInfo.tenantId;
    let token = store.state.token || '';
    if (token) {
      config.headers['Authorization'] = 'Bearer ' + token; // token
    }
    if (TENANT_ID) {
      config.headers['TENANT_ID'] = TENANT_ID; // 租户ID
    }
    // headers中配置serialize为true开启序列化
    if (config.method === 'post' && config.headers.serialize) {
      config.data = serialize(config.data);
      delete config.data.serialize;
    }
    if (config.customHeaders) {
      config.headers = { ...config.headers, ...config.customHeaders };
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// HTTPresponse拦截
service.interceptors.response.use(
  (res) => {
    const status = Number(res.status) || 200;
    const code = res.data.code;
    const message = res.data.msg || errorCode[status] || errorCode['default'];
    if (status === 401 || (code === -1 && message.includes('invalided'))) {
      showToast('登录已失效，请重新登录');
      store.dispatch('LogOut').then(() => {
        router.replace('/login');
      });
      return;
    }
    if (code === -1 && message.includes('请重新登录')) {
      showToast('登录已失效，请重新登录');
      router.replace('/login');
      return;
    }
    if (status !== 200) {
      if (message && typeof message === 'string') {
        showToast(message);
      }
      return Promise.reject(res.data);
    }
    if (code && code !== 0) {
      // showToast(message);
      if (message == '没有找到名为Authorization的header' && router.path !== '/login') {
        showToast('登录已过期，请重新登录');
        router.replace('/login');
      } else {
        // 有些接口需要单独处理错误，不一起提示
        const apis = ['/h5/common/login', '/h5/project-bundle/scan', '/h5/project-bundle/delItemRecord', '/h5/common/verifyIdCardNumber'];
        const isInclude = apis.filter((item) => res.config.url.startsWith(item));
        if (!isInclude.length) {
          if (message && typeof message === 'string') {
            showToast(message);
          }
        }
        return Promise.reject(res.data);
      }
    }
    return res.data;
  },
  (error) => {
    if (error.message.indexOf('timeout') > -1) {
      showToast('请求超时！');
    }
    return Promise.reject(new Error(error));
  }
);

export default service;
